import NewCompanyForm from './NewCompanyForm'
import { useGetUsersQuery } from '../users/usersApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'

const NewCompany = () => {
    useTitle('techCompanies: New Company')


    const content = <NewCompanyForm  />

    return content
}
export default NewCompany